<template>
    <div class="casestudiesmaincontainer">

        <div class="casestudiesfiltercontainer">
          <cmpsearchcasestudies  @sigfilterchanged="fnOnSigfilterchanged" ></cmpsearchcasestudies>
          <cmpfiltercategories   @sigfilterchanged="fnOnSigfilterchanged" ></cmpfiltercategories>
          <cmpfiltertags   @sigfilterchanged="fnOnSigfilterchanged" ></cmpfiltertags>
        </div>
        <div class="casestudiesresultcontainer">
            <cmpcasestudiessmall v-for="item in cases" :key="item.key" :caseitemsmall="item" flagtype="case" >
            </cmpcasestudiessmall>
            <div class="loading" v-if="loading==true">{{waitlabel}}</div>
        </div>
        
    </div>

    <cmpfooter :sticktobottom="sticktobottom"></cmpfooter>
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"
import backendmixin from "../mixins/backendmixin.js"

import cmpfooter from "../components/cmpfooter.vue"
import cmpfiltercategories from "../components/cmpfiltercategories.vue"
import cmpfiltertags from "../components/cmpfiltertags.vue"
import cmpsearchcasestudies from "../components/cmpsearchcasestudies.vue"
import cmpcasestudiessmall from "../components/cmpcasestudiessmall.vue"







export default {
  name: "casestudies",
  mixins:[multilangmixin,backendmixin],
  components:{
    cmpfooter,
    cmpfiltercategories,
    cmpfiltertags,
    cmpsearchcasestudies,
    cmpcasestudiessmall
    
  },
  props:{
    
     "lang":String,
        
  },


  data(){
     return {
          "sticktobottom":false,
          "categoriesready":false,
          "tagsready":false,
          "loading":true
         
                    
      } 
  },





  created(){
     
      
      window.$mitter.on("sigcategoriesready",this.fnOnSigCategoriesReady);
      window.$mitter.on("sigtagsready",this.fnOnSigTagsReady);
      window.$mitter.on("sigcasesready",this.fnOnSigCasesReady);
      
      
    
  },


  computed:{

     waitlabel()
      {
        return this.fnGetTranslation(this.currentlang, "wait");
      },

  },

  
  methods:{

      fnOnSigCategoriesReady(){
          //console.log("fnOnSigCategoriesReady");
          this.categoriesready=true;

          if ((this.categoriesready==true) && (this.tagsready==true))
          {
            this.categoriesready=false;
            this.tagsready=false;
            
            this.fnOnSigfilterchanged();
          }

      },

      fnOnSigTagsReady(){
          //console.log("fnOnSigTagsReady");

          this.tagsready=true;

          if ((this.categoriesready==true) && (this.tagsready==true))
          {
            this.fnOnSigfilterchanged();
          }

      },


      fnOnSigCasesReady(){
          //console.log("fnOnSigCasesReady");

          this.loading=false;

          this.fnOnSigPageResized();

      },



      fnOnSigfilterchanged(){
          const wFilter={  
                            "text":this.$store.state.currentsearch,
                            "category":this.$store.state.currentfiltercategory,
                            "tag":this.$store.state.currentfiltertag,
                            "key":"",
                            "news":false
                        };

          //console.log(wFilter);
          this.loading=true;
          this.fnFetchCaseStudies(wFilter);

      },


      fnSetTimerResized()
      {
        window.setTimeout(this.fnOnSigPageResized,300);
      },

      fnOnSigPageResized()
      {
        this.sticktobottom=false;
        /*
          if (document.body.scrollHeight>window.innerHeight)
          {
            this.sticktobottom=false;
          }
          else
          {
            this.sticktobottom=true;
            
          }
        */

          //console.log(this.sticktobottom,document.body.scrollHeight,window.innerHeight);
      },




 

      

  }



}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>


  .loading{
    width: 100%;
    height: 100%;
    text-align: center;
    padding-top: 10vh;
    font-size: 1.5em;

  
  }


  .casestudiesmaincontainer {
    
    display: flex;

    justify-content: left;
    flex-wrap: wrap;
    flex-direction: row;

    min-height: 50vh;
    
    

  }




  .casestudiesfiltercontainer {
    
    display: flex;
    
    justify-content: left;
    flex-wrap: wrap;
    flex-direction: column;

    min-height:50vh;
    padding: 3vh;

    min-width: 330px;
  }


  
  .casestudiesresultcontainer {
 
    

    display: flex;
    
    justify-content: left;
    flex-wrap: wrap;
    flex-direction: row;

    min-height: 50vh;
    padding: 3vh;
    
    

    /*background-color: beige;*/


    align-content:flex-start;

  }


  
@media screen and (min-width: 700px)    {
      /*  schermo desktop */
    
      .casestudiesfiltercontainer
      {
        width: 270px;
        flex: 0 0 ;
      }



    .casestudiesresultcontainer 
    {
        flex: 1;
    }

  }
  
  @media screen and (max-width: 700px) {
     /*  schermo mobile */
    
    .casestudiesresultcontainer 
    {
        flex: 1;
    }
 
  }


</style>
